const config = {
  ENV: "prod", // change to "dev", "test", or "prod" as needed

  BASE_API_URL: {
    dev: "http://localhost:3001/api",
    test: "https://test.testir.xyz/unichat/api",
    prod: "https://api.aidistrictagents.com/unichat/api",
  },
  BASE_LOGIN_URL: {
    dev: "http://localhost:5174/auth",
    test: "https://testir.xyz/auth",
    prod: "https://aidistrictagents.com/auth",
  },
  AUTH_URL: {
    dev: "http://localhost:3003/api",
    test: "https://api.testir.xyz/portaltest/api",
    prod: "https://api.aidistrictagents.com/server3/api",
  },
  RAG_SYSTEM_URL: {
    dev: "http://localhost:3003/api/system-rag",
    test: "https://api.testir.xyz/portaltest/api/system-rag",
    prod: "https://api.aidistrictagents.com/portaltest/api/system-rag",
  },
  PORTAL_URL: {
    dev: "http://localhost:5174",
    test: "https://testir.xyz",
    prod: "https://aidistrictagents.com"
  },
  WEBSOCKET_URL: {
    dev: "wss://api.aidistrictagents.com/stt",
    test: "wss://api.aidistrictagents.com/stt",
    prod: "wss://api.aidistrictagents.com/stt",
  },
}

// Access current environment's URL
export const BASE_API_URL = config.BASE_API_URL[config.ENV]
export const BASE_LOGIN_URL = config.BASE_LOGIN_URL[config.ENV]
export const BASE_AUTH_URL = config.AUTH_URL[config.ENV]
export const RAG_SYSTEM_URL = config.RAG_SYSTEM_URL[config.ENV]
export const PORTAL_URL = config.PORTAL_URL[config.ENV]
export const WEBSOCKET_URL = config.WEBSOCKET_URL[config.ENV]
export const TOOL_CODE = "P1023"
